import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProjectModelComponent } from '../project-model/project-model.component';
import { ViewportScroller } from '@angular/common';

// declare function require(name:string);
// var FileSaver = require('file-saver');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
public projectsArray = [
    {
      title : 'Fintransformer',
      body : `Fintransformer is an application that allows users and companies to convert their
       financial statements from Russian or from any other language to English. Additionally,
       it allows users to analyze the company's financial health and provide recommendations.`,
      tags : ['Vue', 'MicroServices', 'Docker', 'javaScript', 'Bootstrap', 'Laravel', 'MySQL', 'RESTAPI'],
      image: 'assets/images/portfolio/fintransformer/1.jpg'
    },
    {
      title : 'Group Captain',
      body : `Group Captain acquires rich architectural design to meet real-world problems and capable to handle the process management of macro organizations. The need for application is to simplify different platform's complexity and make application scalable with docker images.
      Group Captain evolves PMS(Project Management System), Organizational Charts(Hierarchical Tree), daily employee work-logs, Access control on Application and Project levels.
      It encapsulates multiple micro-frontend applications wrapped in a main application and behaves like a single application.`,
      tags : ['Angular', 'NodeJS', 'ExpressJS', 'MongoDB', 'MicroServices', 'MicroFrontend', 'Javascript', 'Docker', 'RESTAPI'],
      image: 'assets/images/portfolio/GC/dashboard.jpg'
    },
    {
      title : 'E Parking',
      body : `EParking a web application in which users can put a request for booking a vehicle by select location and time. He/ she can see list of available companies offering parking facilities in his choose time. user select company and put details of his vehicle and his address along with payment details for pay parking fee.
      Application have three different role Admin, Company, User
      Admin can see booking details of current day as well as whole parking's against each company. Overall revenue, users detail, companies information, dashboard charts representation, Admin can also make a roster for each day make charges plan for each company on each day just using drag&drop option. Companies can see their earnings as well the more booking against them the more revenue they get.`,
      tags : ['Vue', 'PHP', 'Laravel', 'MySQL', 'Javascript', 'RESTAPI'],
      image: 'assets/images/portfolio/eparking/index.jpg'
    },
    {
      title : 'agSolutions',
      body : `A web application in which the user wants a CRM base solution using Capsule CRM. Which includes invoicing, quotations system, sales History, sales parties, Notes/task, User Dashboard representing Graphs and Charts.`,
      tags : ['Angular', 'NodeJS', 'MongoDB', 'Javascript', 'RESTAPI'],
      image: 'assets/images/portfolio/eparking/index.jpg'
    },
    {title:'', body:'', tag:[], image: 'assets/images/portfolio/imsaar/imsaar.jpeg'},
    {title:'', body:'', tag:[], image: 'assets/images/portfolio/imsaar/imsaar.jpeg'},
    {title:'', body:'', tag:['PHP', "Laravel", "mysql", "Angular" ], image: 'assets/images/portfolio/agSolution/agsSolution.jpeg'},
    {
      title : 'Imsa ar',
      body : `A web application in which user have multiple dashboard for multiple business integrated at one place like corporate dashboard, customer service portal, reports, sales dashboard, Task Reports etc. each above given dashboard is a sub project of imsaar.`,
      tags : ['React', 'NodeJS', 'MongoDB', 'Javascript', 'RESTAPI'],
      image: 'assets/images/portfolio/imsaar/imsaar.jpeg'
    }
  ]
public months: any = null;

  constructor(private ngbModal: NgbModal, private viewPort: ViewportScroller) { }

  ngOnInit(): void {
    let dateFrom = new Date('2016-10-01');
    let dateTo = new Date('2021-10-15');

    let data = dateTo.getMonth() - dateFrom.getMonth() + (12 * (dateTo.getFullYear() - dateFrom.getFullYear()));
    
    if (data >= 12) {
      
        this.months = (data - data %12)/12 ;
    } else {
        this.months = data;
    }
  }

  scrollToSection(sectionID: string){
    this.viewPort.scrollToAnchor(sectionID);
  }

  projectDetail(index) {
    const modalOptions = { size: 'xl' };
    const ref = this.ngbModal.open(ProjectModelComponent, modalOptions);
    ref.componentInstance.project = this.projectsArray[index];
  }

  // downloadPdf() {
  //   const pdfUrl = './Resume-Muhammad-Bilal.pdf';
  //   const pdfName = 'Resume-Muhammad-Bilal.pdf';
  //   FileSaver.saveAs(pdfUrl, pdfName);
  // }
}
